(function () {
  var launcher = document.getElementById('chekkit-launcher');
  var greeting = document.getElementById('chekkit-greeting');
  var webchat = document.getElementById('webchat');
  var initialized = false;
  var preconnected = false;
  var autoOpenAttempts = 0;
  var autoOpenTimer = null;
  var hasOpened = false;
  var greetingDismissed = false;

  if (!launcher || !webchat) return;

  function preconnectOnce() {
    var link1;
    var link2;

    if (preconnected) return;
    preconnected = true;

    link1 = document.createElement('link');
    link1.rel = 'preconnect';
    link1.href = 'https://chatbot.chekkit.io';
    link1.crossOrigin = 'anonymous';
    document.head.appendChild(link1);

    link2 = document.createElement('link');
    link2.rel = 'dns-prefetch';
    link2.href = '//chatbot.chekkit.io';
    document.head.appendChild(link2);
  }

  function stopAutoOpen() {
    if (autoOpenTimer) {
      clearInterval(autoOpenTimer);
      autoOpenTimer = null;
    }
  }

  function startAutoOpen() {
    if (autoOpenTimer || hasOpened) return;

    autoOpenAttempts = 0;

    autoOpenTimer = setInterval(function () {
      autoOpenAttempts += 1;

      if (window.chekkitSettings && typeof window.chekkitSettings.toggleChat === 'function') {
        window.chekkitSettings.toggleChat();
      }

      if (autoOpenAttempts >= 20 || hasOpened) {
        stopAutoOpen();
      }
    }, 100);
  }

  function dismissGreeting() {
    if (greeting && !greetingDismissed) {
      greeting.classList.add('is-hidden');
      greetingDismissed = true;
    }
  }

  function initChekkit() {
    var dIframeAnchor;
    var nChekkitIFrameContainer;
    var originalBodyOverflowStyle;
    var originalBodyPositionStyle;

    if (initialized) return;
    initialized = true;

    dIframeAnchor = document.createElement('div');
    dIframeAnchor.style.cssText =
      'width: 90px;height: 290px;bottom: 0px;right: 0px;background: transparent;position: fixed;z-index: 20;border: none;overflow: auto;';
    webchat.appendChild(dIframeAnchor);

    nChekkitIFrameContainer = document.createElement('iframe');
    nChekkitIFrameContainer.id = 'chekkit-frame';
    nChekkitIFrameContainer.name = 'chekkit-frame';
    nChekkitIFrameContainer.setAttribute('title', 'Customer support chat widget');
    nChekkitIFrameContainer.setAttribute('role', 'complementary');
    nChekkitIFrameContainer.setAttribute('aria-label', 'Chat with our support team');
    nChekkitIFrameContainer.style.width = '290px';
    nChekkitIFrameContainer.style.height = '220px';
    nChekkitIFrameContainer.style.bottom = '0px';
    nChekkitIFrameContainer.style.right = '0px';
    nChekkitIFrameContainer.style.background = 'transparent';
    nChekkitIFrameContainer.style.position = 'fixed';
    nChekkitIFrameContainer.style.zIndex = 99999999;
    nChekkitIFrameContainer.style.border = 'none';
    nChekkitIFrameContainer.style.overflow = 'auto';

    dIframeAnchor.appendChild(nChekkitIFrameContainer);

    nChekkitIFrameContainer.addEventListener('load', function () {
      startAutoOpen();
    }, { once: true });

    function sendMessageToWidget(msg) {
      if (nChekkitIFrameContainer.contentWindow) {
        nChekkitIFrameContainer.contentWindow.postMessage(msg, '*');
      }
    }

    window.chekkitSettings = window.chekkitSettings || {};
    window.chekkitSettings.toggleChat = function () {
      sendMessageToWidget('toggle chat');
    };

    function bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
      }
    }

    originalBodyOverflowStyle = document.body.style.overflow;
    originalBodyPositionStyle = document.body.style.position;

    bindEvent(window, 'message', function (e) {
      var widthOfTheParentScreen = screen.width;
      var url;
      var domain;
      var isLeft;

      console.log('chekkit message', e.data);

      if (e.data === 'show chat') {
        hasOpened = true;
        stopAutoOpen();

        nChekkitIFrameContainer.style.width = widthOfTheParentScreen > 500 ? '360px' : '100%';
        nChekkitIFrameContainer.style.height = widthOfTheParentScreen > 500 ? '650px' : '100%';
        nChekkitIFrameContainer.width = widthOfTheParentScreen > 500 ? '360px' : '100%';
        nChekkitIFrameContainer.height = widthOfTheParentScreen > 500 ? '650px' : '100%';

        if (widthOfTheParentScreen < 500) {
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
        }

        if (window.gtag && typeof window.gtag === 'function') {
          window.gtag('event', 'Textchat Opened', {
            event_category: 'Textchat',
            event_action: 'Textchat Opened',
            event_label: 'Textchat opened by user'
          });
        }

        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'Textchat Opened',
            eventModel: {
              event_category: 'Textchat',
              event_action: 'Textchat Opened',
              event_label: 'Textchat opened by user'
            }
          });
        }
      }

      if (e.data === 'hide chat') {
        stopAutoOpen();

        nChekkitIFrameContainer.style.width = '90px';
        nChekkitIFrameContainer.style.height = '90px';
        nChekkitIFrameContainer.height = '90px';
        nChekkitIFrameContainer.width = '90px';

        if (widthOfTheParentScreen < 500) {
          document.body.style.overflow = originalBodyOverflowStyle;
          document.body.style.position = originalBodyPositionStyle;
        }
      }

      if (e.data === 'show greeting') {
        nChekkitIFrameContainer.style.width = '290px';
        nChekkitIFrameContainer.style.height = '220px';
        nChekkitIFrameContainer.height = '220px';
        nChekkitIFrameContainer.width = '290px';

        if (widthOfTheParentScreen < 500) {
          document.body.style.overflow = originalBodyOverflowStyle;
          document.body.style.position = originalBodyPositionStyle;
        }
      }

      if (e.data === 'get screen width') {
        sendMessageToWidget('width ' + widthOfTheParentScreen);
      }

      if (e.data === 'get_parent_domain') {
        try {
          url = new URL(window.location.href);
          domain = url.hostname;
          sendMessageToWidget('parent_domain ' + domain);
        } catch (err) {
          sendMessageToWidget('parent_domain unknown');
        }
      }

      if (e.data === 'get_parent_full_url') {
        try {
          sendMessageToWidget('parent_full_url ' + window.location.href);
        } catch (err2) {
          sendMessageToWidget('parent_full_url unknown');
        }
      }

      if (e.data === 'app_id') {
        if (window.chekkitSettings) {
          sendMessageToWidget('app_id ' + window.chekkitSettings.app_id);
        }
      }

      if (e.data && typeof e.data === 'string' && e.data.indexOf('position') !== -1) {
        isLeft = e.data.split(' ')[1] === 'left';
        if (isLeft) {
          nChekkitIFrameContainer.style.right = '';
          nChekkitIFrameContainer.style.left = '0px';
        }
      }

      if (e.data === 'close chat') {
        stopAutoOpen();
        hasOpened = false;

        nChekkitIFrameContainer.style.width = '90px';
        nChekkitIFrameContainer.style.height = '90px';
        nChekkitIFrameContainer.height = '90px';
        nChekkitIFrameContainer.width = '90px';

        if (widthOfTheParentScreen < 500) {
          document.body.style.overflow = originalBodyOverflowStyle;
          document.body.style.position = originalBodyPositionStyle;
        }

        if (window.gtag && typeof window.gtag === 'function') {
          window.gtag('event', 'Textchat Closed', {
            event_category: 'Textchat',
            event_action: 'Textchat Closed',
            event_label: 'Textchat closed by user'
          });
        }

        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'Textchat Closed',
            eventModel: {
              event_category: 'Textchat',
              event_action: 'Textchat Closed',
              event_label: 'Textchat closed by user'
            }
          });
        }
      }

      if (e.data === 'sent message') {
        if (window.gtag && typeof window.gtag === 'function') {
          window.gtag('event', 'Textchat Message', {
            event_category: 'Textchat',
            event_action: 'Textchat Message',
            event_label: 'User sent new Textchat message'
          });
        }

        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'Textchat Message',
            eventModel: {
              event_category: 'Textchat',
              event_action: 'Textchat Message',
              event_label: 'User sent new Textchat message'
            }
          });
        }
      }
    });

    var iframeContent = '<!doctype html>' +
      '<head>' +
      '<title>Customer Support Chat</title>' +
      '<script async defer src="https://chatbot.chekkit.io/v1/widget.js"><\/script>' +
      '</head>' +
      '<body></body>' +
      '</html>';

    if ('srcdoc' in nChekkitIFrameContainer) {
      nChekkitIFrameContainer.srcdoc = iframeContent;
    } else {
      var dataUrl = 'data:text/html;charset=utf-8,' + encodeURIComponent(iframeContent);
      nChekkitIFrameContainer.src = dataUrl;
    }
  }

  // Preconnect on hover/touch/focus
  launcher.addEventListener('mouseenter', preconnectOnce, { once: true });
  launcher.addEventListener('touchstart', preconnectOnce, { once: true, passive: true });
  launcher.addEventListener('focus', preconnectOnce, { once: true });

  // Launcher click: hide itself, dismiss greeting, and initialize
  launcher.addEventListener('click', function () {
    preconnectOnce();
    launcher.style.display = 'none';
    dismissGreeting();
    initChekkit();
  });

  // Greeting click: hide greeting and trigger launcher click
  if (greeting) {
    greeting.addEventListener('mouseenter', preconnectOnce, { once: true });
    greeting.addEventListener('touchstart', preconnectOnce, { once: true, passive: true });
    greeting.addEventListener('focus', preconnectOnce, { once: true });

    greeting.addEventListener('click', function (event) {
      event.preventDefault();
      dismissGreeting();
      launcher.click();
    });
  }
})();